// Personal AI usage chip — self-scoped for every role.
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useSettings } from "@/lib/settings-context";
import { Sparkles, ArrowUpRight } from "lucide-react";

export default function AiUsageWidget() {
    const [d, setD] = useState(null);
    const navigate = useNavigate();
    const { canAccess } = useSettings();
    const canOperations = canAccess("usage_reports");
    useEffect(() => {
        api.get("/home/widget/ai-usage").then((r) => setD(r.data)).catch(() => setD({}));
    }, []);
    const used = d?.used_credits ?? 0;
    const cap  = d?.budget_credits ?? d?.budget ?? 0;
    const pct  = cap > 0 ? Math.min(100, (used / cap) * 100) : 0;
    return (
        <button
            onClick={canOperations ? () => navigate("/usage-reports?view=ai-cost") : undefined}
            disabled={!canOperations}
            className={`border border-border rounded-sm bg-card p-4 h-full w-full text-left group transition-colors ${canOperations ? "hover:border-primary/50 cursor-pointer" : "cursor-default"}`}
            data-testid="home-widget-ai-usage">
            <div className="flex items-center justify-between gap-1.5 mb-3">
                <div className="flex items-center gap-1.5">
                    <Sparkles className="h-3.5 w-3.5 text-primary" />
                    <span className="eyebrow text-[10px]">Your AI · last 30d</span>
                </div>
                {canOperations && <ArrowUpRight className="h-3 w-3 text-muted-foreground opacity-0 group-hover:opacity-100" />}
            </div>
            <div className="kpi-number text-3xl">
                {(d?.credits_30d ?? 0).toLocaleString()} <span className="text-base text-muted-foreground">credits</span>
            </div>
            <div className="text-[11px] text-muted-foreground font-mono mt-1">
                ${d?.cost_30d?.toFixed?.(4) ?? "0.0000"} · {d?.queries_30d ?? 0} queries · {Math.round((d?.tokens_in_30d ?? 0) / 1000)}K in / {Math.round((d?.tokens_out_30d ?? 0) / 1000)}K out
            </div>
            {cap > 0 && (
                <div className="mt-3">
                    <div className="h-1.5 w-full bg-secondary rounded-full overflow-hidden">
                        <div className={`h-full ${pct >= 100 ? "bg-destructive" : pct >= 80 ? "bg-amber-500" : "bg-primary"}`}
                             style={{ width: `${pct}%` }} />
                    </div>
                    <div className="text-[10px] font-mono text-muted-foreground mt-1">
                        {used.toLocaleString()} / {cap.toLocaleString()} credits ({pct.toFixed(0)}%)
                    </div>
                </div>
            )}
            {cap === 0 && (
                <div className="text-[10px] text-muted-foreground/70 font-mono mt-2">No personal credit cap set</div>
            )}
        </button>
    );
}
